export const introBonusesTabHighlighted: boolean = true;
